<h1 mat-dialog-title>{{ mode_label }} ubicación</h1>

<mat-dialog-content [formGroup]="form">
  <div class="dialog-layout">
    <div class="map-column">
      <app-location-map-picker
        [coordinates]="selected_coordinates()"
        (location_change)="setLocation($event)"
        (load_error_change)="setMapLoadError($event)"
        [mode]="mode"
      />

      @if (coordinates_invalid() && map_load_error() === null) {
        <div class="coordinates-error">Selecciona una ubicación válida.</div>
      }
    </div>

    <div class="form-column">
      <mat-form-field appearance="outline">
        <mat-label>Tipo de localización</mat-label>
        @if (is_choose_relatable) {
          <mat-select formControlName="location_type" [canSelectNullableOptions]="true" [disabled]="is_meeting_mode()">
            @for (option of type_options; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        } @else {
          <mat-select [value]="location_type_label" disabled>
            <mat-option [value]="location_type_label">{{ location_type_label }}</mat-option>
          </mat-select>
        }
      </mat-form-field>

      @if (is_choose_relatable && form.value.location_type === LocationRelatableTypeEnum.Company) {
        <app-company-search-dialog
          [restrict_by_permissions]="true"
          [initial_value]="meeting_company_name()"
          (companySelected)="onCompanySelected($event)"
        />
      }

      @if (is_choose_relatable && form.value.location_type === LocationRelatableTypeEnum.PotentialClient) {
        <mat-form-field appearance="outline">
          <mat-label>Cliente potencial</mat-label>
          <input
            matInput
            type="text"
            [formControl]="potential_client_search"
            [matAutocomplete]="potentialClientAutocomplete"
            placeholder="Buscar por nombre, empresa, email o teléfono"
          />
          <mat-autocomplete
            #potentialClientAutocomplete="matAutocomplete"
            [displayWith]="displayPotentialClient.bind(this)"
            (optionSelected)="onPotentialClientSelected($event)"
          >
            @if (potential_client_search_term().length > 0 && potential_client_search_term().length < 3) {
              <mat-option disabled>Escribe al menos 3 caracteres para buscar.</mat-option>
            } @else if (potential_client_search_loading()) {
              <mat-option disabled>
                <mat-spinner diameter="24"></mat-spinner>
              </mat-option>
            } @else if (potential_client_search_term().length >= 3 && filtered_potential_clients.length === 0) {
              <mat-option disabled>No se han encontrado coincidencias.</mat-option>
            } @else {
              @for (client of filtered_potential_clients; track client.id) {
                <mat-option [value]="client">{{ displayPotentialClient(client) }}</mat-option>
              }
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <mat-form-field appearance="outline">
        <mat-label>Nombre</mat-label>
        <input matInput type="text" formControlName="name" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>IPs asociadas</mat-label>
        <mat-chip-grid #chipGridIps formControlName="ips">
          @for (ip of ips; track ip) {
            <mat-chip-row (removed)="removeIp(ip)">
              {{ ip }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
          <input
            #ipInput
            [matChipInputFor]="chipGridIps"
            [matChipInputSeparatorKeyCodes]="[13, 188]"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addIp($event)"
          />
        </mat-chip-grid>
      </mat-form-field>

      @if (map_load_error() !== null) {
        <div class="manual-location-fallback">
          <div class="manual-location-alert">
            <mat-icon>warning</mat-icon>
            <div class="manual-location-alert-content">
              <strong>El mapa no está disponible.</strong>
              <p>Obtén las coordenadas manualmente desde Google Maps en tres pasos:</p>
              <ol>
                <li>Abre Google Maps y busca la dirección de la ubicación.</li>
                <li>Haz clic derecho sobre el punto exacto y copia las coordenadas que aparecen en el menú.</li>
                <li>Pega el primer número en latitud y el segundo en longitud.</li>
              </ol>
            </div>
          </div>

          <div class="manual-location-fields">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Latitud</mat-label>
              <input matInput type="number" inputmode="decimal" autocomplete="off" formControlName="lat" />
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Longitud</mat-label>
              <input matInput type="number" inputmode="decimal" autocomplete="off" formControlName="lon" />
            </mat-form-field>
          </div>

          @if (manual_coordinates_error() !== null) {
            <p class="manual-coordinates-error">{{ manual_coordinates_error() }}</p>
          }
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

@if (mode !== LocationDialogModeEnum.View) {
  <mat-dialog-actions align="end">
    <button mat-flat-button color="accent" class="save-button" type="button" [disabled]="!form.valid || saving()" (click)="submit()">
      @if (saving()) {
        <mat-spinner class="save-button-spinner" diameter="18"></mat-spinner>
      } @else {
        <mat-icon class="save-button-icon">save</mat-icon>
      }
      Guardar
    </button>
  </mat-dialog-actions>
} @else {
  <div class="mb-4"></div>
}
